module.exports = __webpack_public_path__ + "img/Daily-Downloads-of-Selected-Packages-1-1080x926.9be505dd.png";